import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../src/environments/environment'; // Ajusta la ruta a tu entorno

@Injectable({
  providedIn: 'root'
})
export class PersonalService {
  private apiUrl = `${environment.apiUrl}/api/personal`; // Asegúrate de que apunte a tu puerto (ej: 8085)

  constructor(private http: HttpClient) {}

  /**
   * 💾 Envía el payload con los atributos de la entidad Java (nameAlpha, searchType, etc.)
   */
  registrarPersonal(payload: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/register`, payload);
  }

  /**
   * 👥 Descarga el personal interno disponible (Tipos E y M) para el select de usuarios
   */
  getPersonalInternoDisponible(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/interno-disponible`);
  }
}